import { FieldError, Input, Label } from 'components/core-v2/atoms'
import { HTMLProps } from 'react'
import { RegisterOptions, useFormContext } from 'react-hook-form'
import { ClassName } from 'types/props'

import { getFieldIds } from './__utils__/getFieldIds'
import classes from './field.module.scss'

export interface FieldProps extends HTMLProps<HTMLInputElement>, ClassName {
  id: string
  isDisabled?: boolean
  label: string
  placeholder?: string
  showError?: boolean
  type: HTMLProps<HTMLInputElement>['type']
  validators?: RegisterOptions
}

export const Field = ({
  className,
  id,
  isDisabled = false,
  label,
  placeholder,
  showError = true,
  type,
  validators,
  ...props
}: FieldProps) => {
  const {
    formState: { errors },
    register
  } = useFormContext()

  const error = errors[id]?.message
  const hasError = Boolean(error)
  const { describedBy, errorId, inputId } = getFieldIds(id)

  return (
    <div className={className}>
      <Label className={classes.label} htmlFor={id}>
        {label}
      </Label>
      <Input
        aria-describedby={describedBy}
        hasError={hasError}
        id={inputId}
        isDisabled={isDisabled}
        placeholder={placeholder}
        type={type}
        {...props}
        {...register(id, validators)}
      />
      {error && showError && <FieldError id={errorId}>{String(error)}</FieldError>}
    </div>
  )
}
